let configuration = {

    production_url: "https://welicense.blueroominnovation.com",

    capcha: true,

    ipfs: true,
    
    stamina: {

        new_user: 1000,

        send_to_new_user: 200,

        upload_file: -10,

        upload_file_ipfs: -100,

        track_file: -1,

        view_file: -1,

        download_file: -5,

        request_access: 0,

    },
    
    acceptEverything: true
    
};

// Export configuration
module.exports = configuration;
